module.exports = __webpack_public_path__ + "static/media/sv-SE.b8d3bb65.md";